import { Component, input, output } from '@angular/core';

@Component({
    selector: 'pp-users-dropdown-button',
    templateUrl: './users-dropdown-button.component.html',
    styleUrl: './users-dropdown-button.component.scss',
    standalone: false
})
export class UsersDropdownButtonComponent {
  ppSelected = input<boolean>();
  ppSelect = output<void>();
}
